/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(initialState: { currentUser?: API.CurrentUser } | undefined) {
  const { currentUser } = initialState ?? {};
  //
  return {
    can_SysUser_GetPage: (currentUser?.accessList.indexOf('can_SysUser_GetPage') ?? -1) >= 0,
    can_SysUser_Get: (currentUser?.accessList.indexOf('can_SysUser_Get') ?? -1) >= 0,
    can_SysUser_New: (currentUser?.accessList.indexOf('can_SysUser_New') ?? -1) >= 0,
    can_SysUser_Update: (currentUser?.accessList.indexOf('can_SysUser_Update') ?? -1) >= 0,
    can_SysUser_Delete: (currentUser?.accessList.indexOf('can_SysUser_Delete') ?? -1) >= 0,
    can_SysUser_ResetPwd: (currentUser?.accessList.indexOf('can_SysUser_ResetPwd') ?? -1) >= 0,
    can_SysUser_Reset_Password:
      (currentUser?.accessList.indexOf('can_SysUser_Reset_Password') ?? -1) >= 0,

    can_SysMenu_GetPage: (currentUser?.accessList.indexOf('can_SysMenu_GetPage') ?? -1) >= 0,
    can_SysMenu_New: (currentUser?.accessList.indexOf('can_SysMenu_New') ?? -1) >= 0,
    can_SysMenu_Edit: (currentUser?.accessList.indexOf('can_SysMenu_Edit') ?? -1) >= 0,
    can_SysMenu_Delete: (currentUser?.accessList.indexOf('can_SysMenu_Delete') ?? -1) >= 0,

    can_SysRole_GetPage: (currentUser?.accessList.indexOf('can_SysRole_GetPage') ?? -1) >= 0,
    can_SysRole_New: (currentUser?.accessList.indexOf('can_SysRole_New') ?? -1) >= 0,
    can_SysRole_Edit: (currentUser?.accessList.indexOf('can_SysRole_Edit') ?? -1) >= 0,
    can_SysRole_Delete: (currentUser?.accessList.indexOf('can_SysRole_Delete') ?? -1) >= 0,

    can_SysDept_GetPage: (currentUser?.accessList.indexOf('can_SysDept_GetPage') ?? -1) >= 0,
    can_SysDept_New: (currentUser?.accessList.indexOf('can_SysDept_New') ?? -1) >= 0,
    can_SysDept_Edit: (currentUser?.accessList.indexOf('can_SysDept_Edit') ?? -1) >= 0,
    can_SysDept_Delete: (currentUser?.accessList.indexOf('can_SysDept_Delete') ?? -1) >= 0,

    can_SysPost_GetPage: (currentUser?.accessList.indexOf('can_SysPost_GetPage') ?? -1) >= 0,
    can_SysPost_New: (currentUser?.accessList.indexOf('can_SysPost_New') ?? -1) >= 0,
    can_SysPost_Edit: (currentUser?.accessList.indexOf('can_SysPost_Edit') ?? -1) >= 0,
    can_SysPost_Delete: (currentUser?.accessList.indexOf('can_SysPost_Delete') ?? -1) >= 0,

    canDashboard: (currentUser?.accessList.indexOf('canDashboard') ?? -1) >= 0,
    canDashboardWorkplace: (currentUser?.accessList.indexOf('canDashboardWorkplace') ?? -1) >= 0,
    canSupervisorWorkplace: (currentUser?.accessList.indexOf('canSupervisorWorkplace') ?? -1) >= 0,
    canManagerWorkplace: (currentUser?.accessList.indexOf('canManagerWorkplace') ?? -1) >= 0,

    // 许可证权限
    can_PamLicense_GetPage: (currentUser?.accessList.indexOf('can_PamLicense_GetPage') ?? -1) >= 0, // 查看许可证列表
    can_PamLicense_Get: (currentUser?.accessList.indexOf('can_PamLicense_Get') ?? -1) >= 0, // 查看许可证详情
    can_PamLicense_Insert: (currentUser?.accessList.indexOf('can_PamLicense_Insert') ?? -1) >= 0, // 创建许可证
    can_PamLicense_Update: (currentUser?.accessList.indexOf('can_PamLicense_Update') ?? -1) >= 0, // 基本编辑
    can_PamLicense_UpdateAdvanced:
      (currentUser?.accessList.indexOf('can_PamLicense_UpdateAdvanced') ?? -1) >= 0, // 高级配置
    can_PamLicense_Extend: (currentUser?.accessList.indexOf('can_PamLicense_Extend') ?? -1) >= 0, // 延期操作
    can_PamLicense_Activate:
      (currentUser?.accessList.indexOf('can_PamLicense_Activate') ?? -1) >= 0, // 激活/停用
    can_PamLicense_Delete: (currentUser?.accessList.indexOf('can_PamLicense_Delete') ?? -1) >= 0, // 删除许可证
    can_PamLicense_ManageAll:
      (currentUser?.accessList.indexOf('can_PamLicense_ManageAll') ?? -1) >= 0, // 全部管理

    // 部署服务器权限
    can_PamDeployServer_GetPage:
      (currentUser?.accessList.indexOf('can_PamDeployServer_GetPage') ?? -1) >= 0,
    can_PamDeployServer_Insert:
      (currentUser?.accessList.indexOf('can_PamDeployServer_Insert') ?? -1) >= 0,
    can_PamDeployServer_Update:
      (currentUser?.accessList.indexOf('can_PamDeployServer_Update') ?? -1) >= 0,
    can_PamDeployServer_Delete:
      (currentUser?.accessList.indexOf('can_PamDeployServer_Delete') ?? -1) >= 0,

    // 部署任务权限
    can_PamDeployTask_GetPage:
      (currentUser?.accessList.indexOf('can_PamDeployTask_GetPage') ?? -1) >= 0,
    can_PamDeployTask_Create:
      (currentUser?.accessList.indexOf('can_PamDeployTask_Create') ?? -1) >= 0,
    can_PamDeployTask_Cancel:
      (currentUser?.accessList.indexOf('can_PamDeployTask_Cancel') ?? -1) >= 0,

    // 服务器设备监控与磁盘清理权限（202608/001）—— 只读组（查看指标/预览待删清单）随服务器列表权限放开，
    // 清理执行组（真正执行删除/改配置）作为独立权限点，见 API 契约 5.5
    can_PamServerCleanup_Safe:
      (currentUser?.accessList.indexOf('can_PamServerCleanup_Safe') ?? -1) >= 0, // 安全项一键清理
    can_PamServerCleanup_Dangerous:
      (currentUser?.accessList.indexOf('can_PamServerCleanup_Dangerous') ?? -1) >= 0, // 危险项确认清理
    can_PamCleanupConfig_Update:
      (currentUser?.accessList.indexOf('can_PamCleanupConfig_Update') ?? -1) >= 0, // 修改清理阈值配置

    // 安全管理权限
    can_Security_Acknowledge:
      (currentUser?.accessList.indexOf('can_Security_Acknowledge') ?? -1) >= 0, // 确认告警
    can_Security_Freeze: (currentUser?.accessList.indexOf('can_Security_Freeze') ?? -1) >= 0, // 确认盗版冻结
    can_Security_Resolve: (currentUser?.accessList.indexOf('can_Security_Resolve') ?? -1) >= 0, // 确认误报恢复
    can_Security_Investigate:
      (currentUser?.accessList.indexOf('can_Security_Investigate') ?? -1) >= 0, // 添加调查备注
    can_Security_Config: (currentUser?.accessList.indexOf('can_Security_Config') ?? -1) >= 0, // 修改许可证安全配置
    can_PamLicense_Freeze: (currentUser?.accessList.indexOf('can_PamLicense_Freeze') ?? -1) >= 0, // 手动冻结许可证
    can_PamLicense_Unfreeze:
      (currentUser?.accessList.indexOf('can_PamLicense_Unfreeze') ?? -1) >= 0, // 解冻许可证

    // 代码自动插入标记(勿删)
  };
  // return currentUser?.accessList
}
